/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ClinicRequestType =
  (typeof ClinicRequestType)[keyof typeof ClinicRequestType];

export const ClinicRequestType = {
  ASYNC_DX: "ASYNC_DX",
  ASYNC_RX: "ASYNC_RX",
  RX_RENEWAL: "RX_RENEWAL",
  VISIT: "VISIT",
} as const;
